/**
 * 路由配置
 * @Description: 网站路由总配置文件
 *
 * @Author: JZT.Oscar
 * @Date: 2018-09-28 08:39:21
 * @Last Modified by: JZT.lmy
 * @Last Modified time: 2019-02-20 15:46:06
 */
import Vue from "vue";
import Router from "vue-router";
import MenuView from "@/layouts/MenuView";
import Login from "@/pages/login/Login";
import RouterState from "@/store/modules/router";
import store from "../store";
import { setTimeout } from "timers";
// import Home from "@/pages/home/Home";

// 加载各模块路由
import systemRoutes from "./system";
import goodsRoutes from "./goods";
// import dashboardRoutes from "./dashboard";
// import demoRoutes from "./demo";
import customerRoutes from "./customer";
import fundsRoutes from "./funds";
import orderRoutes from "./order";
import contentRoutes from "./content";
import marketingRoutes from "./marketing";
import labelsRoutes from "./labels";
import flowDirectionRoutes from "./flowDirection";

import frontPage from "@/router/frontPage";
import NoticeRoutes from './notice'
import ResultRoutes from './result'
import InvoiceRoutes from './invoice'

Vue.use(Router);

const VueRouterPush = Router.prototype.push;
Router.prototype.push = function push(to) {
    try {
        VueRouterPush.call(this, to);
    } catch (e) {
        console.log(e);
    }
};

const router = new Router({
    mode: "history",
    // 增加二级目录，本后台程序需要代理到前台网站的二级目录 admin 下
    // 需要配合 config/index.js 中的 assetsPublicPath 字段使用
    base: "sass",
    routes: [
        ...frontPage,
        {
            path: "/index",
            name: 'index',
            component: () => import('@/pages/frontPage/home')
        },
        {
            path: '/quality',
            name: 'quality',
            component: () => import('@/pages/frontPage/home/quality')
        },
        {
            path: "/",
            name: "首页总",
            redirect: "/home",
            component: MenuView,
            icon: "none",
            invisible: true,
            children: [
                {
                    path: "/home",
                    name: "首页",
                    component: () => import("@/pages/home/Home"),
                    icon: "none",
                    invisible: false,
                    meta: {
                        comName: "Home"
                    }
                },
                // ...dashboardRoutes,
                ...systemRoutes,
                ...goodsRoutes,
                // ...demoRoutes,
                ...customerRoutes,
                ...orderRoutes,
                ...contentRoutes,
                ...marketingRoutes,
                ...fundsRoutes,
                ...labelsRoutes,
                ...flowDirectionRoutes,
                ...NoticeRoutes,
                ...ResultRoutes,
                ...InvoiceRoutes
            ]
        }
    ]
});

router.beforeEach((to, from, next) => {
    // 查找同类型组件
    let index = RouterState.state.routeList.findIndex(
        item => item.path === to.path
    );
    if (
        index > -1 &&
        RouterState.state.routeList[index].fullPath !== to.fullPath
    ) {
        store.commit("router/removeFromKeepAlive", {
            from: "routerBefore",
            comName: to.meta.comName
        });
        setTimeout(() => {
            next();
        }, 200);
    } else {
        next();
    }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js